module.exports = __webpack_public_path__ + "static/media/reforzada.4471b683.jpg";